<template>
  <div>
    <Splash v-if="isSplash == true" />
    <div class="top_content">
      <div class="side_left">
        <div class="academic-content1 d-flex justify-center align-center">
          <div>
            <p>
              <span class="title_page">
                Sedih Nilai Ujianmu Selalu Paling Rendah di Kelas?
                <br />Padahal, kamu sudah belajar hingga larut malam dan ikut
                les sana sini <br />
              </span>

              <br />
              <span class="tag_on_top mb-2">
                KAMU GAK PERLU SEDIH LAGI!
                <br />
              </span>
              <br />
              <span class="title_page">
                Psikotes Academic Psychogram akan membantumu dalam menemukan
                gaya belajar yang tepat untukmu dan aspek-aspek penunjang
                prestasi akademik lainnya
              </span>
              <!-- <span style="font-size: 28px">Psikotes Academic Psychogram!</span> -->
            </p>
            <v-card
              color="#910b62"
              width="max-content"
              dark
              class="pa-2 mb-4 button-kemudian"
            >
              Kemudian raih nilai akadademis yang gemilang!
            </v-card>
            <div class="button2">
              <v-btn
                color="green"
                dark
                href="https://wa.wizard.id/8578dc"
                class="text-capitalize mr-2"
                rounded
              >
                <v-icon>mdi-whatsapp</v-icon> Daftar Psikotes Sekarang</v-btn
              >
              <v-btn
                class="rounded-lg"
                color="#380A52"
                dark
                href="#first-content"
                ><span style="font-weight: bold; color: white"
                  >Lihat Lebih Lanjut</span
                ></v-btn
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content2-wrapper" style="width: 40%; z-index: 3">
        <img
          class="content2-image mt-10"
          src="../../assets/img/academicPsychogram/smartphone.png"
        />
      </div>
    </div>
    <!-- <div class="academic-landing">
      <img
        class="academic-img-landing"
        src="../../assets/img/academicPsychogram/background-landing.png"
      />
      <div
        class="academic-text content1-wrapper"
        style="width: 60%; z-index: 2"
      >
        <div class="academic-content1 d-flex justify-center align-center">
          <div>
            <p>
              <span class="title_page"> Academic Psychogram</span> <br />
              Sedih Nilai Ujianmu Selalu Paling Rendah Dikelas? <br />
              <span class="tag_on_top mb-2"
                >SEBENARNYA,
                <br />
                SUDAHKAH KAMU TAHU ASPEK-ASPEK AKADEMIS
                <br />
                YANG DAPAT MENUNJANG PRESTASIMU?
              </span>
              <br />
              TEMUKAN! Melalui
              <span style="font-size: 28px">Psikotes Academic Psychogram!</span>
            </p>
            <v-btn class="rounded-lg" color="#380A52" dark href="#first-content"
              ><span style="font-weight: bold; color: white"
                >Lihat Lebih Lanjut</span
              ></v-btn
            >
          </div>
        </div>
      </div>
      
    </div> -->
    <div class="d-flex justify-center">
      <img
        class="content2-image-mobile"
        src="../../assets/img/academicPsychogram/smartphone.png"
      />
    </div>
    <div class="py-5" id="first-content">
      <h2 class="academic-text text-center">APA ITU ACADEMIC PSYCHOGRAM?</h2>
      <p class="text-center academic-text pa-1">
        Academic Psychogram Merupakan Psikotes yang Dapat Membantumu
        menemu-kenali minat, kekuatan dan kelemahanmu, sehingga kamu bisa
        memaksimalkan Potensi yang ada dalam dirimu, untuk menunjang pencapaian
        Prestasi Akademik yang Gemilang.
      </p>
    </div>
    <div>
      <div class="temp_chat d-flex align-center">
        <img
          src="../../assets/img/academicPsychogram/chat1.png"
          class="img_chat1"
          alt=""
        />
        <div
          class="temp_txt academic-text rounded-lg"
          style="background: #f2f9f6"
        >
          Loh bagaimana bisa Psikotes Academic Psychogram bisa Ningkatin
          Prestasi Academic saya?
        </div>
      </div>
    </div>

    <div class="d-flex justify-end add_matop">
      <div class="temp_chat d-flex">
        <div>
          <div
            class="temp_txt academic-text rounded-lg"
            style="background: #29ba26"
          >
            <p class="white--text mb-0">
              Dengan Academic Psychogram kamu akan mengetahui apa yang menjadi
              Kelemahan dan kekuatanmu, yang mana kelemahan itu bisa kamu
              perbaiki supaya tidak menghambat prestasi mu, dan kekuatanmu bisa
              kamu maksimalkan untuk menunjang prestasimu semakin gemilang.
            </p>
          </div>
          <div
            class="temp_txt academic-text rounded-lg mt-5"
            style="background: #29ba26"
          >
            <p class="white--text mb-0">
              Tak hanya itu Academic Psychogram ini juga akan memberitahumu gaya
              belajar yang cocok untukmu, sehingga belajar bukan lagi hal yang
              perlu kamu hindari, ditambah kamu akan mengetahui minat yang ada
              dalam dirimu dan kamu akan mendapatkan rekomendasi Jurusan Kuliah
              yang sesuai dengan minat tersebut.
            </p>
          </div>
        </div>
        <img
          src="../../assets/img/academicPsychogram/chat2.png"
          class="img_chat2"
          alt=""
        />
      </div>
    </div>

    <div>
      <div class="mt-12">
        <h2 class="academic-text text-center">
          Makin penasaran apa saja minat, kelebihan dan kekuranganmu? <br />
          TEMUKAN SEKARANG ! DAN RAIH PRESTASI ACADEMIC GEMILANG!
        </h2>
      </div>
      <div class="d-flex justify-center align-center my-12">
        <v-card
          width="200"
          color="380A52"
          dark
          class="rounded-lg d-flex justify-center align-center mx-2"
          style="height: 100px; font-size: 30px"
        >
          {{ hour }}
        </v-card>
        <v-card
          width="200"
          color="380A52"
          dark
          class="rounded-lg d-flex justify-center align-center mx-2"
          style="height: 100px; font-size: 30px"
        >
          {{ minute }}
        </v-card>
        <v-card
          width="200"
          color="380A52"
          dark
          class="rounded-lg d-flex justify-center align-center mx-2"
          style="height: 100px; font-size: 30px"
        >
          {{ second }}
          <v-img
            class="harga-image"
            src="../../assets/img/academicPsychogram/harga.png"
            style="width: 200px !important"
          ></v-img>
        </v-card>
      </div>
      <div>
        <p class="text-center">
          Penawaran akan berakhir setelah angka menunjukkan 00:00:00
        </p>
      </div>
      <div class="d-flex justify-center align-center">
        <v-btn
          href="https://wa.wizard.id/8578dc"
          color="success"
          class="rounded-xl"
        >
          <v-icon>mdi mdi-whatsapp</v-icon>
          KLIK DISINI UNTUK DAFTAR</v-btn
        >
      </div>
    </div>
    <div class="mt-2 bahaya-image-mobile">
      <v-img
        src="../../assets/img/academicPsychogram/bahaya.png"
        style="width: 200px !important"
      ></v-img>
    </div>
    <div class="d-flex justify-center align-center my-10 pa-5">
      <div id="bahaya-image" class="d-flex justify-center align-center">
        <v-img
          src="../../assets/img/academicPsychogram/bahaya.png"
          style="width: 200px !important"
        ></v-img>
      </div>
      <div id="bahaya-content" style="width: 50%" class="bahaya-content pa-5">
        <h2 style="color: #8c0f85">Bahaya Tidak Mengenali Diri Sendiri</h2>
        <div>
          <h3>Membuang Waktu</h3>
          <p>
            Karena terus berkutat pada suatu yang kamu tidak minati dan kamu
            ungguli, sehingga apa yang kamu lakukan tidak maksimal.
          </p>
        </div>
        <div>
          <h3>Sering menyalahkan orang lain</h3>
          <p>
            Cenderung sering menyalahkan orang lain atau kondis ketika
            dihadapkan pada kondisi yang sulit, karena tidak mengetahui
            kelemahan dan kekuatan diri sendiri.
          </p>
        </div>
      </div>
    </div>
    <div class="mengenali_mobile bahaya-image-mobile">
      <v-img
        src="../../assets/img/academicPsychogram/cari.png"
        style="width: 200px !important"
      ></v-img>
      <v-btn
        href="https://wa.wizard.id/8578dc"
        color="success"
        class="rounded-xl mt-2"
      >
        <v-icon>mdi mdi-whatsapp</v-icon>
        Daftar Psikotes Sekarang</v-btn
      >
    </div>
    <div class="d-flex justify-center align-center my-5 pa-5">
      <div style="width: 50%" class="pa-5" id="bahaya-content">
        <h2 style="color: #8c0f85">Manfaat Mengenali Diri Sendiri</h2>
        <div>
          <ol>
            <li>Mudah memaksimalkan Kelebihan yang ada dalam diri</li>
            <li>Mampu memperbaiki kelemahan dalam diri</li>
            <li>Mudah membangun komunikasi dengan orang lain</li>
            <li>Mampu Menentukan Pilihan & Tujuan Hidup</li>
            <li>Jadi lebih tahu potensi diri</li>
          </ol>
        </div>
      </div>
      <div id="bahaya-image">
        <v-img
          src="../../assets/img/academicPsychogram/cari.png"
          style="width: 200px !important"
        ></v-img>
        <v-btn
          href="https://wa.wizard.id/8578dc"
          color="success"
          class="rounded-xl mt-2"
        >
          <v-icon>mdi mdi-whatsapp</v-icon>
          Daftar Psikotes Sekarang</v-btn
        >
      </div>
    </div>

    <div class="feedback_psyco">
      <div class="kata-mereka">
        <h2 class="text-center">Apa Kata Mereka?</h2>
        <v-card
          dark
          color="#8C0F85"
          class="pa-5 mt-5 rounded-xl content_katamereka"
        >
          <p style="color: white">
            "Ternyata aku semakin percaya sama jurusan yang aku mau ka setelah
            ikut psikotes, aku plih 2 jurusan dan aku cocok di kedua jurusan
            itu" ~ Yulvia
          </p>
        </v-card>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "../../components/penjurusan/Footer.vue";
import Splash from "../../components/penjurusan/Splash.vue";

export default {
  name: "academic-psychogram",
  components: {
    Footer,
    Splash,
  },
  data() {
    return {
      date: this.$date().hour(2),
      isSplash: true,
    };
  },
  computed: {
    all: function () {
      return this.date.format("hh:mm:ss");
    },
    hour: function () {
      return this.date.format("hh");
    },
    minute: function () {
      return this.date.format("mm");
    },
    second: function () {
      return this.date.format("ss");
    },
  },
  mounted() {
    setInterval(() => {
      this.date = this.$date(this.date.subtract(1, "seconds"));
    }, 1000);
    setTimeout(() => {
      this.isSplash = false;
    }, 2000);
  },
};
</script>

<style>
.top_content {
  background: url("../../assets/img/bg_jumbotron.png");
  height: 100vh;
  display: flex;
  background-position-y: 60%;
  background-position-x: 50%;
}
.side_left {
  width: 60%;
}
.feedback_psyco {
  background: url("../../assets/img/bg_apaya.png");
  height: 50vh;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.tag_on_top {
  font-size: 30px;
  font-weight: 800;
  color: #910b62;
}
.academic-text {
  color: #380a52;
}
.academic-landing {
  height: 100vh;
  display: flex;
}
.academic-img-landing {
  width: 90%;
  position: absolute;
  right: 0;
  margin-top: -1%;
  margin-right: -20%;
  z-index: 0;
}
.academic-content1 {
  padding: 10px 40px 0 40px;
  font-weight: bold;
  font-size: 18px;
  height: 80vh;
}
.content2-image {
  width: 80%;
}

.rounded-img {
  width: 71px;
  height: 70px;
  border-radius: 50%;
}
.content2-image-mobile {
  display: none;
}
.bahaya-image-mobile {
  display: none;
}
.harga-image {
  position: absolute;
  right: 0;
  margin-right: -185px;
  margin-top: 120px;
  transform: rotate(-45deg);
}

/* =======================chat */
.temp_chat {
  padding: 0 20px;
  width: 70%;
  margin-bottom: 15px;
}
.temp_txt {
  padding: 20px;
}
.img_chat1 {
  width: 100px;
  height: 70px;
  object-fit: cover;
  margin-right: 10px;
}
.img_chat2 {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-left: 10px;
}
.kata-mereka {
  padding: 0 50px 0 0;
}
.content_katamereka {
  width: 400px;
}

@media (max-width: 768px) {
  .top_content {
    padding-right: 40px;
    height: max-content;
    background-position-y: 70%;
    background-position-x: 100%;
    color: white !important;
  }
  .button2 {
    margin-bottom: 10px;
  }
  .button2 a {
    width: 100% !important;
    margin-bottom: 5px;
  }
  .tag_on_top {
    color: white !important;
  }
  .side_left {
    width: 100%;
  }
  .feedback_psyco {
    justify-content: center;
    align-items: flex-start;
  }
  .kata-mereka {
    padding: 20px;
  }
  .academic-content1 {
    height: max-content;
    padding: 10px 0px 0 50px;
  }
  .button-kemudian {
    width: 100% !important;
    text-align: center;
  }
  .tag_on_top {
    font-size: 20px;
    font-weight: 600;
  }
  .academic-img-landing {
    display: none;
  }
  .content1-wrapper {
    height: max-content;
    width: 100% !important;
  }
  .content2-wrapper {
    display: none;
  }
  #button-lanjut {
    margin-top: 20px !important;
  }
  .content2-image-mobile {
    display: inline;
    width: 200px;
  }
}
@media (max-width: 576px) {
  /* =======================chat */
  .temp_chat {
    width: 100%;
    position: relative;
  }
  .temp_txt {
    padding: 20px;
    padding-top: 30px;
  }
  .img_chat1 {
    position: absolute;
    width: 50px;
    height: 50px;
    margin-top: -120px;
    border-radius: 50%;
  }
  .add_matop {
    margin-top: 40px;
  }
  .content_katamereka {
    width: 100%;
  }
  .img_chat2 {
    position: absolute;
    right: 0;
    width: 60px;
    height: 60px;
    margin-top: -30px;
    border-radius: 50%;
  }
  .academic-landing {
    height: max-content;
    margin-top: 5%;
  }
  .title_page {
    font-size: 15px;
  }
  .academic-img-landing {
    display: none;
  }
  .content1-wrapper {
    width: 100% !important;
  }
  .content2-wrapper {
    display: none;
  }
  #button-lanjut {
    margin-top: 20px !important;
  }
  .chat2 {
    width: 100% !important;
  }

  #bahaya-image {
    display: none !important;
  }
  #bahaya-content {
    width: 100% !important;
  }
  .content2-image-mobile {
    display: inline;
    width: 200px;
  }
  .bahaya-image-mobile {
    display: inline;
  }
  .mengenali_mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .harga-image {
    display: none;
  }
}
</style>
